import React from 'react';
import _ from 'lodash';

import tailRightIcon from 'assets/icons/tail-right.svg';
import arrowRight from 'assets/icons/arrow-right.svg';

import Tooltip from 'components/Tooltip';
import IconButton from 'components/IconButton';
import BookingStatus from 'components/BookingStatus';
import {BookingType} from 'containers/FrontDesk/components/shared';

import {OtherBookingMembers} from './components';

import {formatDate} from 'utils/datetime';

import './styles.css';

const StickyTableSubRow = ({tenant}) => (
  <div className="StickyTableSubRow colab-centered-v">
    <div className="StickyTableSubRow__name colab-bold colab-centered-v">
      {tenant.fullName}
    </div>
    <div className="StickyTableSubRow__status colab-centered-v">-</div>
    <div className="StickyTableSubRow__type colab-centered-v">-</div>
    <div className="StickyTableSubRow__start colab-centered-v">-</div>
    <div className="StickyTableSubRow__end colab-centered-v">-</div>
  </div>
);

const TOOLTIP_NAME = 'bookingsTableTooltip';

const StickyBookingRow = ({
  booking,
  redirectToBookingDetail,
  toggleBookingRow,
  openedBookings
}) => {
  return (
    <React.Fragment>
      <div className="StickyBookingRow colab-centered-v">
        <div className="StickyBookingRow__arrow">
          <IconButton
            src={arrowRight}
            alt="Hide tab"
            onClick={() => toggleBookingRow({bookingId: booking.id})}
          />
        </div>
        <div
          className="StickyBookingRow__booking colab-clickable colab-link colab-bold"
          onClick={() => redirectToBookingDetail({bookingId: booking.id})}>
          #{booking.id}
        </div>
        <div className="StickyBookingRow__members">
          <div className="StickyBookingRow__members__primary">
            {booking.primaryTenant.fullName}
          </div>
          <OtherBookingMembers booking={booking} />
        </div>
        <div className="StickyBookingRow__status">
          <BookingStatus status={booking.status} />
        </div>
        <div className="StickyBookingRow__type">
          <div
            data-tip={JSON.stringify({
              type: 'bookingType',
              content: booking.bookingType
            })}
            data-for={TOOLTIP_NAME}>
            <BookingType bookingType={booking.bookingType} />
          </div>
        </div>
        <div className="StickyBookingRow__start colab-row-space-between">
          {formatDate(booking.periodStartDate)}
          <img src={tailRightIcon} alt="arrow" />
        </div>
        <div className="StickyBookingRow__end">
          {formatDate(booking.periodEndDate)}
        </div>
      </div>
      {_.includes(openedBookings, booking.id) &&
        !_.isEmpty(booking.primaryTenant) && (
          <StickyTableSubRow tenant={booking.primaryTenant} />
        )}
      {_.includes(openedBookings, booking.id) &&
        _.get(booking, 'secondaryTenant.fullName') && (
          <StickyTableSubRow tenant={booking.secondaryTenant} />
        )}
      {_.includes(openedBookings, booking.id) &&
        _.get(booking, 'guarantor.fullName') && (
          <StickyTableSubRow tenant={booking.guarantor} />
        )}
    </React.Fragment>
  );
};

interface BookingsForMonthProps {
  month: string;
  bookings: any;
  redirectToBookingDetail: any;
  toggleBookingRow: ({bookingId: number}) => void;
  openedBookings: Array<number>;
}

class StickyBookingsForMonth extends React.Component<BookingsForMonthProps> {
  render() {
    const {
      month,
      bookings,
      redirectToBookingDetail,
      toggleBookingRow,
      openedBookings
    } = this.props;

    return (
      <div className="StickyBookingsForMonth">
        <div className="StickyBookingsForMonth__header colab-bold colab-centered-v">
          {month}
        </div>
        <div className="StickyBookingsForMonth__content">
          {_.map(bookings, booking => {
            return (
              <StickyBookingRow
                key={booking.id}
                booking={booking}
                redirectToBookingDetail={redirectToBookingDetail}
                toggleBookingRow={toggleBookingRow}
                openedBookings={openedBookings}
              />
            );
          })}
        </div>
        <Tooltip
          place="left"
          effect="solid"
          id={TOOLTIP_NAME}
          getContent={tooltipData =>
            (tooltipData && JSON.parse(tooltipData).content) || ''
          }
        />
      </div>
    );
  }
}

export default StickyBookingsForMonth;
